"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const checkpayment = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-checkpayment` : '') + (description ? ` desc-checkpayment` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-checkpayment"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-checkpayment"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 .13a2 2 0 0 1 2 2v19.75a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2.13c0-1.1.9-2 2-2h34Zm0 .5H3c-.78 0-1.42.6-1.5 1.36v19.89c0 .78.6 1.42 1.36 1.5H37c.78 0 1.42-.6 1.5-1.36V2.13c0-.78-.6-1.42-1.36-1.5H37Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m17.31 13.6-2.15.3.31-2.14 5.52-5.52a1.3 1.3 0 0 1 1.84 1.84L17.3 13.6Z",
    stroke: "#232323",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.6 9.33h-1.74a.87.87 0 0 0-.86.87v6.07a.87.87 0 0 0 .86.87h11.28a.87.87 0 0 0 .86-.87V10.2a.87.87 0 0 0-.86-.87h-.87",
    stroke: "#232323",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.27 14.97h-4.34",
    stroke: "#232323",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.27 12.8h-2.6",
    stroke: "#232323",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var _default = exports.default = checkpayment;